// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modal Overlay */
.referral-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

/* Modal Container */
.referral-modal {
  position: relative;
  background: white;
  padding: 30px 20px;
  border-radius: 12px;
  max-width: 500px;
  width: 90%;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
  text-align: center;
}

/* Toast Message */
.referral-toast {
  position: absolute;
  top: 0.5rem;
  left: 50%;
  transform: translateX(-50%);
  background-color: #d4edda;
  color: #155724;
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 0.9rem;
  animation: fadeInOut 2s ease forwards;
  pointer-events: none;
}

@keyframes fadeInOut {
  0% { opacity: 0; }
  10% { opacity: 1; }
  90% { opacity: 1; }
  100% { opacity: 0; }
}

/* Title and Subtext */
.referral-title {
  font-size: 1.3rem;
  font-weight: 700;
  margin-bottom: 5px;
  color: #222;
}

.referral-subtext {
  font-size: 0.95rem;
  color: #555;
  margin-bottom: 20px;
  line-height: 1.4;
}

.referral-modal h2,
.referral-modal h3 {
  margin: 15px 0 8px;
  font-size: 1rem;
  font-weight: 600;
  color: #333;
}

/* Referral Row */
.referral-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
}

.referral-row input {
  flex: 1 1;
  padding: 10px;
  font-size: 0.95rem;
  border: 1px solid #ccc;
  border-radius: 6px;
  overflow-x: auto;
  white-space: nowrap;
}

.referral-row button {
  padding: 10px 14px;
  background-color: #007bff;
  color: white;
  font-size: 0.9rem;
  font-weight: 500;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  min-width: 110px;
  white-space: nowrap;
  transition: background-color 0.3s ease;
}

.referral-row button:hover {
  background-color: #0056b3;
}

/* Add this new wrapper to center-align the button */
.referral-close-btn-wrapper {
  display: flex;
  justify-content: center;
  margin-top: 24px;
}

/* Enhance the Close button styling */
.close-btn {
  padding: 10px 24px;  /* ensures left and right spacing */
  background-color: #6c757d;
  color: white;
  font-size: 0.95rem;
  font-weight: 500;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  min-width: 140px;
  text-align: center;
}

.close-btn:hover {
  background-color: #545b62;
}

/* Optional top-right close "X" */
.referral-modal-close-x {
  position: absolute;
  top: 15px;
  right: 15px;
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #555;
}

.referral-modal-close-x:hover {
  color: #000;
}

/* Responsive */
@media (max-width: 480px) {
  .referral-modal {
    padding: 20px 15px;
  }

  .referral-title {
    font-size: 1.1rem;
  }

  .referral-subtext {
    font-size: 0.9rem;
  }

  .referral-row {
    flex-direction: column;
    align-items: stretch;
  }

  .referral-row input {
    width: 100%;
  }

  .referral-row button {
    width: 100%;
    margin-top: 8px;
  }

  .close-btn {
    width: 100%;
    margin-top: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ReferralModal.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,2BAA2B;EAC3B,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,qCAAqC;EACrC,oBAAoB;AACtB;;AAEA;EACE,KAAK,UAAU,EAAE;EACjB,MAAM,UAAU,EAAE;EAClB,MAAM,UAAU,EAAE;EAClB,OAAO,UAAU,EAAE;AACrB;;AAEA,sBAAsB;AACtB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,oDAAoD;AACpD;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,qCAAqC;AACrC;EACE,kBAAkB,GAAG,mCAAmC;EACxD,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sCAAsC;EACtC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA,eAAe;AACf;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;AACF","sourcesContent":["/* Modal Overlay */\n.referral-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n}\n\n/* Modal Container */\n.referral-modal {\n  position: relative;\n  background: white;\n  padding: 30px 20px;\n  border-radius: 12px;\n  max-width: 500px;\n  width: 90%;\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);\n  text-align: center;\n}\n\n/* Toast Message */\n.referral-toast {\n  position: absolute;\n  top: 0.5rem;\n  left: 50%;\n  transform: translateX(-50%);\n  background-color: #d4edda;\n  color: #155724;\n  padding: 8px 16px;\n  border-radius: 6px;\n  font-size: 0.9rem;\n  animation: fadeInOut 2s ease forwards;\n  pointer-events: none;\n}\n\n@keyframes fadeInOut {\n  0% { opacity: 0; }\n  10% { opacity: 1; }\n  90% { opacity: 1; }\n  100% { opacity: 0; }\n}\n\n/* Title and Subtext */\n.referral-title {\n  font-size: 1.3rem;\n  font-weight: 700;\n  margin-bottom: 5px;\n  color: #222;\n}\n\n.referral-subtext {\n  font-size: 0.95rem;\n  color: #555;\n  margin-bottom: 20px;\n  line-height: 1.4;\n}\n\n.referral-modal h2,\n.referral-modal h3 {\n  margin: 15px 0 8px;\n  font-size: 1rem;\n  font-weight: 600;\n  color: #333;\n}\n\n/* Referral Row */\n.referral-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 20px;\n}\n\n.referral-row input {\n  flex: 1;\n  padding: 10px;\n  font-size: 0.95rem;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  overflow-x: auto;\n  white-space: nowrap;\n}\n\n.referral-row button {\n  padding: 10px 14px;\n  background-color: #007bff;\n  color: white;\n  font-size: 0.9rem;\n  font-weight: 500;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  min-width: 110px;\n  white-space: nowrap;\n  transition: background-color 0.3s ease;\n}\n\n.referral-row button:hover {\n  background-color: #0056b3;\n}\n\n/* Add this new wrapper to center-align the button */\n.referral-close-btn-wrapper {\n  display: flex;\n  justify-content: center;\n  margin-top: 24px;\n}\n\n/* Enhance the Close button styling */\n.close-btn {\n  padding: 10px 24px;  /* ensures left and right spacing */\n  background-color: #6c757d;\n  color: white;\n  font-size: 0.95rem;\n  font-weight: 500;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n  min-width: 140px;\n  text-align: center;\n}\n\n.close-btn:hover {\n  background-color: #545b62;\n}\n\n/* Optional top-right close \"X\" */\n.referral-modal-close-x {\n  position: absolute;\n  top: 15px;\n  right: 15px;\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: #555;\n}\n\n.referral-modal-close-x:hover {\n  color: #000;\n}\n\n/* Responsive */\n@media (max-width: 480px) {\n  .referral-modal {\n    padding: 20px 15px;\n  }\n\n  .referral-title {\n    font-size: 1.1rem;\n  }\n\n  .referral-subtext {\n    font-size: 0.9rem;\n  }\n\n  .referral-row {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .referral-row input {\n    width: 100%;\n  }\n\n  .referral-row button {\n    width: 100%;\n    margin-top: 8px;\n  }\n\n  .close-btn {\n    width: 100%;\n    margin-top: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
